module.exports = __webpack_public_path__ + "files/07bf5f0fec6c4e2ad5139ca910063c01.png";